import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { OneTimePaymentRequest, OneTimePaymentResponse, WebCompany, WebCustomer } from "../../../../../models";
import { MatDialogRef } from "@angular/material/dialog";
import { CompanyService, CustomerService } from "../../../../../services";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-print-chase-receipt",
  templateUrl: "./print-chase-receipt.component.html",
  styleUrls: ["./print-chase-receipt.component.scss"]
})
export class PrintChaseReceiptComponent implements OnInit, OnDestroy
{

  @Input() paymentInfo: OneTimePaymentRequest;
  @Input() otpResponse: any;

  public customer: WebCustomer;
  public customerSubscription: Subscription;
  public company: WebCompany;

  public totalAmount: number;
  public amountPaid: number;
  public fees: number;
  public refNo: string;


  public date: string;

  constructor(
    public dialogRef: MatDialogRef<PrintChaseReceiptComponent>,
    public customerService: CustomerService,
    public companyService: CompanyService) { }

  ngOnInit(): void
  {

    this.date = new Date().toLocaleDateString();
    this.amountPaid = this.paymentInfo.APSPayment.Amount;
    this.totalAmount = this.paymentInfo.APSPayment.Amount + (this.paymentInfo.APSPayment.ConvenienceFee == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFee) + (this.paymentInfo.APSPayment.ConvenienceFeeTax == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFeeTax);
    this.fees = (this.paymentInfo.APSPayment.ConvenienceFee == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFee) + (this.paymentInfo.APSPayment.ConvenienceFeeTax == null ? 0 : this.paymentInfo.APSPayment.ConvenienceFeeTax);
    this.refNo = this.otpResponse.ReferenceNumber;
    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });

    this.companyService.company.subscribe(comp =>
    {
      this.company = comp;
    });
  }

  printReceipt()
  {

    window.print();

  }
  public handleClose(): void
  {
    this.dialogRef.close();
  }
  ngOnDestroy(): void 
  {
    this.customerSubscription.unsubscribe();
  }
}
